<template lang="pug">
aside-modal(id="labelModal", width="w-xxxl", :loading="loading")
    span(slot="header-text") {{ labelExists ? 'Update' : 'Create' }} Label
    div.p-a(slot="body")
        form(id="labelForm")
            fieldset(:disabled="loading")
                div.md-form-group
                    input.md-input(
                        placeholder="e.g Cluster A",
                        type="text",
                        v-model="label.name",
                        :readonly="!canManageLabel"
                        required
                    )
                    label Name
                    span.help-block.m-b-none Use &nbsp;
                      span.label.rounded.danger ::
                      | &nbsp; to create a scoped label set (eg. &nbsp;
                      span.label.rounded.danger priority::1
                      | &nbsp;)

                div.form-group.p-b-sm
                  div
                    span.typo__label.multiselect-label Description
                  div.p-t-sm
                    textarea.form-control(
                          name="description"
                          v-model='label.description'
                    )

                div.form-group.p-b-sm
                  div
                    span.typo__label.multiselect-label Station
                  a.pull-right.m-r-sm(data-dismiss="modal")
                  | {{ label.outlets ? label.outlets.length : 0 }} stations selected
                  div.p-t-sm
                    button.btn.btn-sm.btn-block.white(data-toggle="modal"
                    data-target="#m-a-a",
                    ui-toggle-class="fade-up-big",
                    ui-target="#animate",
                    @click="show_station_list()"
                    ) Select stations


                div.form-group.p-b-sm
                  div
                    span.typo__label.multiselect-label Background Color
                  div.p-t-sm
                    v-input-colorpicker(
                      v-model="label.color",
                      @input="handleColor"
                    )

                hr


                div.form-group.p-b-sm
                  div
                    span.typo__label.multiselect-label Preview
                  div.m-b-lg(v-if="!isScope")
                    div.badge(data-color="light")
                        div.badge-text(:style="{ backgroundColor: previewColor}")
                            span {{previewName}}
                  div.m-b-lg(v-else)
                    div.badge(data-color="light")
                        div.badge-text-left(:style="{ backgroundColor: previewColor }")
                            span {{first}}
                        div.badge-text-right(:style="{ outline: outletStyle }")
                            span {{second}}

    button.btn.btn-fw.primary(
        slot="footer",
        @click="submit()",
        :disabled="onLoading('save-label')"
        v-if="canManageLabel"
    )
        v-loading(loader="save-label") Save
</template>

<script>
import EventBus from '@js/franchise_component/common/event-bus';
import { mapActions, mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';

export default {
    data() {
        return {
            label: null,
            outlets_loading: false,
            outletStyle: '2px solid #000000',
            first: null,
            second: null,
        };
    },

    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
        loading() {
            return (
                this.onLoading('fetch-label') || this.onLoading('save-label')
            );
        },

        labelExists() {
            return this.label.id !== null;
        },

        previewName() {
            return this.label.name != null ? this.label.name : 'Label';
        },

        previewColor() {
            return this.label.color != null ? this.label.color : '#000000';
        },

        canManageLabel() {
            return Auth.hasPermissionTo('franchise_manage_labels');
        },

        isScope() {
            return this.getScope(this.label.name);
        },
    },

    created() {
        this.label = this.newLabel();
        this.$on('label-updated', outlets => {
            this.label.outlets = outlets;
        });
    },

    mounted() {
        this.registerEvent();
    },

    methods: {
        ...mapActions('label', ['getLabel', 'updateLabel', 'createLabel']),

        newLabel() {
            return {
                id: null,
                name: null,
                outlets: [],
                stations: [],
            };
        },

        toggleModal(action) {
            $('#labelModal').modal(action);
        },

        registerEvent() {
            this.$on('show-label', id => {
                if (this.loading) return;

                if (id === null) {
                    this.label = this.newLabel();
                    this.toggleModal('show');
                } else {
                    this.getLabel(id)
                        .then(res => {
                            this.toggleModal('show');
                            this.label = _.pick(res.data, [
                                'id',
                                'name',
                                'description',
                                'color',
                                'outlets',
                                'stations',
                            ]);
                        })
                        .catch(err => {
                            this.showApiError(err);
                        });
                }
            });
        },

        submit() {
            /** Promise */
            let save;

            if (!this.validateForm('labelForm')) return;

            const outlets = this.label.outlets.map(p => p.id);

            const label = Object.assign(
                _.pick(this.label, ['id', 'name', 'description', 'color']),
                {
                    outlets,
                },
            );

            if (!this.labelExists) {
                save = this.createLabel(label);
            } else {
                save = this.updateLabel(label);
            }

            save.then(res => {
                this.showToastrSuccess();

                if (this.labelExists) {
                    this.toggleModal('hide');
                } else {
                    this.label = this.newLabel();
                }

                this.$emit('label-saved');
            }).catch(err => {
                this.showApiError(err);
            });
        },

        show_station_list() {
            this.$emit('showupStation', this.label);
        },

        handleColor(value) {
            this.label.color = value;
        },

        getScope(name) {
            let filter = ['::'];
            let scopes = _.some(filter, el => _.includes(name, el));

            if (scopes) {
                let split = name.split('::');
                this.second = split[split.length - 1];
                let first_data = _.dropRight(split);
                this.first = _.join(first_data, '::');
                this.outletStyle =
                    this.label.color != null
                        ? '2px solid ' + this.label.color
                        : '2px solid #000000';
                return true;
            }

            return false;
        },
    },
};
</script>
